import {createActions} from 'client/framework';

export default createActions(null, ['HIDE_MODAL', 'SHOW_MODAL']);
